import React, { Component }      from 'react';
import { connect }               from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import { SetCadastroGrupo }      from '../../../actions/grupoAction';
import renderField               from '../../../container/renderField';
import renderCheckbox               from '../../../container/renderFieldCheckBox';
import renderFieldSelec          from '../../../container/renderFieldSelect';
import validate                  from '../../../service/validate_equipe';
import { ActionModal }           from '../../../actions/scopoAction';
import EquipeAdicionarAluno      from './equipe_adicionar_aluno_equipe';
import FlashCarregando           from '../../../container/FlashCarregando';
import { SetError }         from '../../../actions/authenticActions';

class equipe_professor_form extends Component {

    constructor(props){

        super(props);
        this.state = {
                    equ_id           : 0,
                    dis_id           : this.props.all_equipe_turma.dis_id,
                    tur_id           : this.props.all_equipe_turma.tur_id,
                    use_id           : this.props.session.id,
                    equ_rand         : false,
                    form             : 1,
                    status_form      : false,
                    equ_nome         : 'teste',
                    equ_disciplina   : 'teste',
                    load             : false,
                    actionSelect          : false,
                    button                : true,
                    listNomesEquipes      : [],
                    listaForm             : "",
                    ar                    : 1,
                    nome_form_nova_equipe : ''
                   }

        this.setState({ equ_rand: this.props.tipo });
    }

    componentWillMount() {
     
        if(this.props.acao>0) {
           this.props.initialize({equ_nome : this.props.dadosForm.equ_nome});
           this.setState({equ_id : this.props.dadosForm.equ_id})
        }

        this.setState({ nome_form_nova_equipe: 'Equipe '+(this.props.qtd_equipes+1) });
    }


    retornoNomesEquipe(){

        const ar = this.state.ar;
        const listaEquipes =  this.state.listNomesEquipes;

        for(var i=1; i<=ar; i++){
            listaEquipes.push(document.getElementsByName(`equ_nome${i}`)[0].value);
        }
    }

    handleSubmit(e) {

        const equ_rand = (e.equ_rand === undefined?false:(e.equ_rand.length>0?true:false))
       
       this.retornoNomesEquipe();

        this.props.SetCadastroGrupo(this.state,equ_rand).then(
        (response) =>{
            this.setState({
                            equ_id : response.payload.data.equ_id,
                            form   : 2,
                            load   : true,
                            equ_nome: response.payload.data.equ_nome
                          });

          alert('Ação realizada com sucesso!');
           this.props.ActionModal(false);
           this.setState({listNomesEquipes:[]});

        }).catch((error) =>{
          this.props.SetError(500);
        });
   }
    
    fecharEquipe(){
        this.props.ActionModal(false);
    }

    changeSelectEquipes(ev){
        var qtd_inputs_equipes = ev.target.value;

        if (qtd_inputs_equipes > 0) {

            var listaform = [];
            var cont = 1;
            for (var i = 1; i <= qtd_inputs_equipes; i++) {

                listaform.push(<Field name={`equ_nome${i}`} valueForm={`Equipe ${cont}`} component={renderField} />);
                cont++;
            }

            this.setState({ ar: qtd_inputs_equipes, status_form: true, listaform: listaform, actionSelect: true, button: false })

        } else {
            this.setState({ status_form: false, actionSelect: false, button: true });
        }
    }

    render() {


        const {handleSubmit} = this.props;

        const form = (
                        <div className="panel panel-default">
                            <div className="panel-heading"><h4>Cadastrar equipe</h4></div>
                            <div className="panel-body">
                              
                                { this.props.tipo ?

                                    <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                        <Field
                                            name="qtd_equipes"
                                            component={renderFieldSelec}
                                            onChange={this.changeSelectEquipes.bind(this)}
                                            label="Quantidade de equipes"
                                            option={[0, 2, 3, 4, 5, 6].map((elem, i) => { return <option key={i} value={elem}>{elem} </option> })}
                                        />
                                        {this.state.actionSelect ? this.state.listaform.map((elem, i) => { return <div key={i}>{elem}</div> }) : ""}
                                        {this.state.actionSelect ? <Field name="equ_rand" label="Sortear alunos aleatórios para cada equipe" itemValue={true} component={renderCheckbox} /> : ""}
                                        <hr />
                                        <button type="button" className="btn btn-danger btn-sm pull-left" onClick={this.fecharEquipe.bind(this)}>Fechar</button>
                                        <button type="submit" className="btn btn-primary btn-sm pull-right" disabled={this.state.button}>Enviar</button>
                                    </form>

                                    :

                                    <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                        <label>Nome da equipe</label>
                                        <input
                                            className="form-control"
                                            name="equ_nome1"
                                            type="text"
                                            placeholder="Nome da equipe"
                                            value={this.state.nome_form_nova_equipe}
                                            onChange={e => this.setState({ nome_form_nova_equipe: e.target.value })}
                                        />
                                        <hr/>
                                        <button type="button" className="btn btn-danger btn-sm pull-left" onClick={this.fecharEquipe.bind(this)}>Fechar</button>
                                        <button type="submit" className="btn btn-primary btn-sm pull-right">Enviar</button>
                                    </form> }
                            </div>                
                        </div>
                      );

        return (
                <div>
                {this.state.form ===1? form : (this.state.load ? <EquipeAdicionarAluno equ_nome = {this.state.equ_nome} equ_id={this.state.equ_id}/>:<FlashCarregando/>)}
                </div>
               );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('equipe'));

function mapStateToProps(state){

        return {

           all_equipe_turma : state.equipeReducer.all_equipe_turma, 
           session          : state.auth.session,
           allEquipes       : state.equipeReducer.all_equipe_turma,
           nome_turma       : state.equipeReducer.nome_turma,
           menu             : state.configReducer.menu,
           actionModal      : state.scopoReducer.actionModal

        };
  }


export default reduxForm({
  form                     : 'equipe',
  destroyOnUnmount         : true, 
  forceUnregisterOnUnmount : true, 
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps,{ SetCadastroGrupo,ActionModal,SetError})(equipe_professor_form));





// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor_form.js